import { render, staticRenderFns } from "./ChannelsPanel.vue?vue&type=template&id=e67a1360"
import script from "./ChannelsPanel.vue?vue&type=script&lang=js"
export * from "./ChannelsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports